module.exports = __webpack_public_path__ + "img/slash.c6f7141b.svg";